import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { DATE_FORMAT_FOR_API } from "../../constants/constants";
import { startDownloadData } from "../../libs/utils";
import {
  resetDownloadDocument
} from "../../store/actions/download/index";
import { loadPreview } from "../../store/actions/deadlines/preview";
import {
  getNumberPagesAttachments,
  getDeadlineDetail,
  setDeadlineDetailViewed,
  getDailyTotals
} from "../../store/actions/deadlines/detail";

import DeadlinesDetails from "../../components/deadlines/details";
import DownloadProgress from "../../components/downloadProgress/index";
import LoaderSimple from "../../components/general/loader";
import NoPermissionsView from "./noPermissionsView";
import Page from "../../components/general/page";
import useChangeCompany from "../../customHooks/useChangeCompany";
import { useLocation } from "react-router-dom";
import { useIntl } from "react-intl";

const DetailDeadlinesView = ({ isFullscreenOverlay, pageRef }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const idByUrl = !isFullscreenOverlay
    ? location.pathname.split("scadenza/")[1]
    : null;

  const [currentDetailId, setCurrentDetailId] = useState(idByUrl); // ??
  const [isFirstLoad, setIsFirstLoad] = useState(true); // lo uso per caricare eventuali dettagli di allegati

  /** lastId: props.deadlinesDetail.subjective
      ? props.deadlinesDetail.subjective.id
      : "", // serve a getDerivedStateFromProps usare con parsimonia
     */
  const [lastId, setLastId] = useState("");

  const company = useSelector(state => state.company);
  const deadlinesCompany = useSelector(state => state.deadlinesCompany);
  const deadlinesDetail = useSelector(state => state.deadlinesDetail);
  const download = useSelector(state => state.download);
  const main = useSelector(state => state.main);
  const companyUuidSelected = main.companyUuidSelected;
  const myType = main.myType;
  const prevPath = main.prevPath;
  const companySelected = main.companySelected;
  const clientIdSelected = main.clientIdSelected;
  const isGettingDeadlines = deadlinesDetail.isGettingDeadlines;
  const subjective = deadlinesDetail.subjective;

  const intl = useIntl();

  const { changeCompanySelected } = useChangeCompany();

  let filteredCompany;
  if (deadlinesDetail.subjective) {
    filteredCompany = company.companies.find(el => {
      return el.id === deadlinesDetail.subjective.itemId;
    });
  }

  let backMonth = "";
  if (deadlinesCompany.subjective) {
    if (deadlinesCompany.subjective.length > 0) {
      backMonth = `?m=${new Date(deadlinesCompany.subjective[0].date).getMonth() + 1}`;
    }
  }

  let renderComponent;

  useEffect(() => {
    document.getElementsByTagName("body")[0].style.overflow = "auto";
    if (idByUrl)
      getDetailDetailsById(currentDetailId);
  }, []);

  useEffect(() => {
    const currentId = deadlinesDetail.subjective
      ? deadlinesDetail.subjective.id
      : "";
    if (isFirstLoad || currentId !== lastId) {
      setIsFirstLoad(false);
      setLastId(currentId);
    }
  }, [deadlinesDetail?.subjective?.id]);

  useEffect(() => {
    if (
      download &&
      download.status.ended &&
      download.content
    ) {
      startDownloadData(download);
      dispatch(resetDownloadDocument());
    }
  }, [download?.content, download?.status.ended]);

  useEffect(() => {
    const currentDeadline  = !isFullscreenOverlay
      ? location.pathname.split("scadenza/")[1]
      : null;
    setCurrentDetailId(currentDeadline);
    getDetailDetailsById(currentDeadline);

  }, [location.pathname]);

  useEffect(() => {
    if (!isFullscreenOverlay) return;
    const idDeadlines = main?.widgets?.fullscreenOverlay?.params?.payload ? main.widgets.fullscreenOverlay.params.payload.deadlineId : null;

    getDetailDetailsById(idDeadlines);
    setCurrentDetailId(idDeadlines);
  }, [isFullscreenOverlay, main?.widgets?.fullscreenOverlay?.params?.payload?.deadlineId]);

  const getDetailDetailsById = (deadlineId) => {

    dispatch(getDeadlineDetail(deadlineId)).then(deadline => {
      // Se la scadenza è di un cliente diverso da quello selezionato,
      // allora cambio cliente dalla select in alto
      //
      if (
        deadlinesDetail.subjective &&
        deadlinesDetail.subjective.itemId &&
        companyUuidSelected !== deadlinesDetail.subjective.itemId
      ) {
        const companyId = company.companies.filter(x => x.uuid === deadlinesDetail.subjective.itemId);
        // Se viene richiamato la change company per il cliente,
        // viene fatta un doppio caricamento con perdita dell'url se si
        // proviene dalla mail di notifica
        if (myType === "STUDIO") {
          changeCompanySelected(companyId[0].id);
        }
        if (deadline.attachments && deadline.attachments.length > 0) {
          dispatch(loadPreview(
            companyId[0].id,
            deadline.attachments[0].id,
            0
          ));

          dispatch(getNumberPagesAttachments(
            companyId[0].id,
            companyId[0].id,
            deadline.attachments
          ));
        }
        getDailyTotals(moment(deadline.date).format(DATE_FORMAT_FOR_API));
      } else {

        dispatch(getDailyTotals(moment(deadline.date).format(DATE_FORMAT_FOR_API)));

        if (deadline.attachments && deadline.attachments.length > 0) {
          dispatch(loadPreview(
            clientIdSelected,
            deadline.attachments[0].id,
            0
          ));

          dispatch(getNumberPagesAttachments(
            companySelected,
            clientIdSelected,
            deadline.attachments
          ));
        }
      }

      if (
        deadline.status &&
        myType !== "STUDIO" &&
        !deadline.status.viewed
      ) {
        dispatch(setDeadlineDetailViewed(currentDetailId,
          true));
      }
    });
  };

  switch (true) {
  case isGettingDeadlines:
    renderComponent = <LoaderSimple />;
    break;
  case !isGettingDeadlines && subjective === null && !isFullscreenOverlay:
    renderComponent = <NoPermissionsView />;
    break;
  case subjective && !isGettingDeadlines:
    renderComponent = <DeadlinesDetails      
      isFullscreenOverlay={isFullscreenOverlay}
      getDetailDetailsById={getDetailDetailsById}
    />;
    break;
  default:
    renderComponent = null;
    break;
  }

  return (
    <Page
      pageRef={pageRef}
      activePage="/scadenze"
      className="contentStructure transparent settings"      
      title={"SCADENZA"}
      isFullscreenOverlay={isFullscreenOverlay}
      subtitle={
        filteredCompany
          ? `${filteredCompany.ragioneSociale} / ${intl.formatMessage({ id: "generic.fiscalCodeAbbreviation" })} ${filteredCompany.codiceFiscale}`
          : ""
      }
      backText="Torna indietro"
      backUrl={
        window.location.href.indexOf("from=scheda_cliente") > -1
          ? "/scheda-cliente"
          : window.location.href.indexOf("from=dashboard") > -1
            ? "/"
            : prevPath.includes("dettaglio-documento")
              ? prevPath
              : (myType === "STUDIO"
                ? location.state &&
                  location.state.fromSchedaCliente
                  ? "/scadenzecliente"
                  : "/scadenze"
                : "/scadenzecliente") + backMonth
      }
    >
      <DownloadProgress />

      {renderComponent}
    </Page>
  );
};

export default DetailDeadlinesView;
